export function FormControl(state, setState) {
  const setFormState = (valueObj) => {
    setState((prevState) => ({ ...prevState, ...valueObj }));
  };

  const resetFormState = () => {
    setState({});
  };

  const removeEntries = (keys) => {
    let tempState = state;

    (keys || []).forEach((key) => {
      delete tempState[key];
    });

    setState(tempState);
  };

  return {
    setFormState,
    resetFormState,
    removeEntries,
  };
}
